import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["paymentType", "rechargeAmount", "discountAmount", "rechargePercentage", "discountPercentage", "netAmount", "grossAmount", "submitButton"];

  static values = {
    debug: Boolean
  }

  // Guardar el valor original del display al conectar
  originalDisplayValue = null;

  // Método helper para verificar si los targets de pago existen
  hasPaymentTargets() {
    return this.hasGrossAmountTarget &&
           this.hasNetAmountTarget &&
           this.hasPaymentTypeTarget;
  }

  connect() {
    this.debug = true; // Habilitar logs de depuración

    // Si no hay targets de pago, el formulario no tiene campos de pago, salir temprano
    if (!this.hasPaymentTargets()) {
      if (this.debug) {
      }
      return;
    }

    // Deshabilitar el botón de confirmar al inicio
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = true;
      if (this.debug) {
      }
    }

    this.paymentRules = JSON.parse(this.element.dataset.paymentRules);

    // Asegurarse de que los campos de recargo/descuento estén inicializados en 0
    if (this.hasRechargeAmountTarget) {
      this.rechargeAmountTarget.value = 0;
    }
    if (this.hasDiscountAmountTarget) {
      this.discountAmountTarget.value = 0;
    }

    // CRÍTICO: Leer el valor inicial del display y usarlo como base
    // El display siempre tiene el valor correcto, mientras que el campo oculto puede tener un valor incorrecto
    const totalToPayDisplay = document.getElementById('total_to_pay_display');
    let initialDisplayValue = null;
    if (totalToPayDisplay) {
      const displayText = totalToPayDisplay.textContent.trim();
      // Intentar parsear el valor del display (formato: "$ 24.500" o "$ 24.500,00" o "$ 24,500.00")
      // El formato argentino usa punto para miles y coma para decimales (o sin decimales)
      // Ejemplo: "$ 24.500" -> 24500, "$ 24.500,00" -> 24500.00
      let displayNumbers = displayText.replace(/[^\d.,]/g, ''); // Remover todo excepto dígitos, puntos y comas
      // Si tiene punto y coma, asumir formato argentino (punto = miles, coma = decimal)
      if (displayNumbers.includes('.') && displayNumbers.includes(',')) {
        displayNumbers = displayNumbers.replace(/\./g, '').replace(',', '.'); // Quitar puntos (miles) y convertir coma a punto
      } else if (displayNumbers.includes(',')) {
        // Solo tiene coma, podría ser decimal
        displayNumbers = displayNumbers.replace(',', '.');
      } else if (displayNumbers.includes('.')) {
        // Solo tiene punto, asumir que son miles (formato argentino sin decimales)
        displayNumbers = displayNumbers.replace(/\./g, ''); // Quitar puntos (miles)
      }
      initialDisplayValue = parseFloat(displayNumbers);

      if (this.debug) {
      }

      // Guardar el valor original del display para uso futuro
      this.originalDisplayValue = initialDisplayValue;

      if (this.debug) {
      }
    }

    // Inicializar el monto final con el subtotal
    // Usar el valor del display si está disponible, sino usar el campo oculto
    if (this.hasGrossAmountTarget && this.hasNetAmountTarget) {
      const grossAmountValue = this.grossAmountTarget.value;
      const grossAmount = parseFloat(grossAmountValue);

      if (this.debug) {
      }

      // Si el valor del display está disponible y es diferente del campo oculto, usar el display
      let baseAmount = grossAmount;
      if (initialDisplayValue !== null && Math.abs(initialDisplayValue - grossAmount) > 0.01) {
        if (this.debug) {
          console.warn(`[payment_form] connect - Discrepancia detectada: display=${initialDisplayValue}, campo_oculto=${grossAmount}`);
          console.warn(`[payment_form] connect - Usando valor del display como base: ${initialDisplayValue}`);
        }
        baseAmount = initialDisplayValue;
        // Actualizar el campo oculto con el valor correcto
        this.grossAmountTarget.value = initialDisplayValue.toFixed(2);
      }

      // Validar que el valor parseado es un número válido y razonable (no más de 1 millón de pesos)
      if (!isNaN(baseAmount) && baseAmount > 0 && baseAmount < 1000000) {
        // Solo actualizar el campo net_amount, no el total a pagar en la tabla
        // El total a pagar en la tabla se actualizará cuando se seleccione un método de pago
        this.netAmountTarget.value = baseAmount.toFixed(2);

        if (this.debug) {
        }
      } else if (this.debug) {
        console.warn(`[payment_form] connect - baseAmount es inválido o fuera de rango: ${baseAmount}`);
      }
    }

    if (this.debug) {
    }

    // Resetear formulario cuando se cierre el modal
    const modal = document.getElementById('orderSummary');
    if (modal) {
      modal.addEventListener('hidden.bs.modal', () => {
        this.resetForm();
      });
      // También para Bootstrap 4
      $(modal).on('hidden.bs.modal', () => {
        this.resetForm();
      });
    }
  }

  updateAmounts() {
    // Verificar si los targets existen antes de continuar
    if (!this.hasPaymentTargets()) {
      return;
    }

    const paymentType = this.paymentTypeTarget.value;
    if (!paymentType) {
      if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = true;
      }
      return;
    }

      // CRÍTICO: Usar el valor original del display guardado al conectar
      // Si no está disponible, intentar leerlo del display actual
      let displayValue = this.originalDisplayValue;

      if (displayValue === null || displayValue === undefined) {
        // Si no tenemos el valor original, intentar leerlo del display
        const totalToPayDisplay = document.getElementById('total_to_pay_display');
        if (totalToPayDisplay) {
          const displayText = totalToPayDisplay.textContent.trim();
          // Intentar parsear el valor del display (formato: "$ 24.500" o "$ 24.500,00" o "$ 24,500.00")
          // El formato argentino usa punto para miles y coma para decimales (o sin decimales)
          // Ejemplo: "$ 24.500" -> 24500, "$ 24.500,00" -> 24500.00
          let displayNumbers = displayText.replace(/[^\d.,]/g, ''); // Remover todo excepto dígitos, puntos y comas
          // Si tiene punto y coma, asumir formato argentino (punto = miles, coma = decimal)
          if (displayNumbers.includes('.') && displayNumbers.includes(',')) {
            displayNumbers = displayNumbers.replace(/\./g, '').replace(',', '.'); // Quitar puntos (miles) y convertir coma a punto
          } else if (displayNumbers.includes(',')) {
            // Solo tiene coma, podría ser decimal
            displayNumbers = displayNumbers.replace(',', '.');
          } else if (displayNumbers.includes('.')) {
            // Solo tiene punto, asumir que son miles (formato argentino sin decimales)
            displayNumbers = displayNumbers.replace(/\./g, ''); // Quitar puntos (miles)
          }
          displayValue = parseFloat(displayNumbers);

          if (this.debug) {
          }

          if (this.debug) {
          }
        }
      } else if (this.debug) {
      }

    // Convertir valores a números
    // El campo oculto grossAmount debería tener un número puro (ej: "49000.0"), no formateado
    const grossAmountRaw = this.grossAmountTarget.value;
    let grossAmount = parseFloat(grossAmountRaw) || 0;

    // SIEMPRE usar el valor del display si está disponible
    if (displayValue !== null && displayValue > 0) {
      if (this.debug) {
      }
      if (Math.abs(displayValue - grossAmount) > 0.01) {
        console.warn(`[payment_form] updateAmounts - Discrepancia detectada: display=${displayValue}, campo_oculto=${grossAmount}`);
      }
      grossAmount = displayValue;
      // Actualizar el campo oculto con el valor correcto
      this.grossAmountTarget.value = displayValue.toFixed(2);
    } else if (this.debug) {
      console.warn(`[payment_form] updateAmounts - No se pudo obtener el valor del display, usando campo oculto: ${grossAmount}`);
    }

    const netAmount = parseFloat(this.netAmountTarget.value) || 0;

    // Validar que el grossAmount sea razonable (no más de 10 millones de pesos)
    // Si es mayor, probablemente hay un error en el valor del campo oculto
    if (grossAmount > 10000000) {
      console.error(`[payment_form] ERROR CRÍTICO: grossAmount es excesivamente grande: ${grossAmount}`);
      console.error(`[payment_form] Valor raw del campo oculto: "${grossAmountRaw}"`);
      console.error(`[payment_form] Esto sugiere que el campo oculto tiene un valor incorrecto.`);
      console.error(`[payment_form] Revisar el cálculo de gross_amount_units en el HTML.`);
      // No continuar con el cálculo si el valor es claramente incorrecto
      return;
    }

    this.grossAmountTarget.value = grossAmount.toFixed(2);

    // Guardar el valor actual del descuento manual para restaurarlo después
    const currentDiscountAmount = parseFloat(this.discountAmountTarget.value) || 0;

    if (this.debug) {
    }

    const rules = this.paymentRules[paymentType];

    if (this.debug) {
    }

    if (!rules) {
      // No existe regla para este medio de pago
      this.rechargeAmountTarget.value = 0;
      this.rechargePercentageTarget.value = '';
      this.discountPercentageTarget.value = '';
      this.netAmountTarget.value = grossAmount.toFixed(2);
      this.submitButtonTarget.disabled = true;
      // Limpiar payment_type para que no se envíe
      this.paymentTypeTarget.value = '';

      // Mostrar mensaje de error
      this.showRuleError("No hay regla configurada para este medio de pago. Por favor, configure la regla en la sección Ventas > Reglas de Pago.");
      return;
    }

    // Validar que la regla tenga AMBOS porcentajes configurados (no nil)
    // nil = no configurado, 0 = configurado pero no aplica, > 0 = configurado y aplica
    // Una regla está correctamente configurada si ambos porcentajes no son null (pueden ser 0)
    if (rules.recharge_percentage == null || rules.discount_percentage == null) {
      // La regla existe pero no está completamente configurada (al menos un porcentaje es nil)
      this.rechargeAmountTarget.value = 0;
      this.rechargePercentageTarget.value = '';
      this.discountPercentageTarget.value = '';
      this.netAmountTarget.value = grossAmount.toFixed(2);
      this.submitButtonTarget.disabled = true;
      // Limpiar payment_type para que no se envíe
      this.paymentTypeTarget.value = '';

      // Mostrar mensaje de error
      this.showRuleError("Esta regla de pago no está completamente configurada. Por favor, configure ambos porcentajes (use 0 si no aplica) en Ventas > Reglas de Pago.");
      return;
    }

    // Ocultar mensaje de error si existe
    this.hideRuleError();

    // Mostrar información sobre la regla aplicada
    // Los montos fijos (recharge_amount y discount_amount) son manuales, no vienen de la regla
    // Solo aplicamos los porcentajes de la regla
    // nil = no configurado, 0 = configurado pero no aplica, > 0 = configurado y aplica
    // IMPORTANTE: solo debemos aplicar recargos/descuentos si el porcentaje es > 0
    // Si hay reglas configuradas, usar esos valores; si no, usar 0 (no aplicar recargos/descuentos)
    const rechargePercentage = rules.recharge_percentage != null ? rules.recharge_percentage : 0;
    const discountPercentage = rules.discount_percentage != null ? rules.discount_percentage : 0;

    // Mostrar información sobre la regla aplicada
    this.showRuleInfo(rechargePercentage, discountPercentage);

    // Actualizar los campos readonly de porcentajes (para mostrar y enviar)
    // Forzar la actualización del DOM para asegurar que los valores se muestren correctamente
    if (this.hasRechargePercentageTarget) {
    this.rechargePercentageTarget.value = rechargePercentage;
      // Ya no forzamos un evento de cambio para evitar bucles infinitos
    }

    if (this.hasDiscountPercentageTarget) {
    this.discountPercentageTarget.value = discountPercentage;
      // Ya no forzamos un evento de cambio para evitar bucles infinitos
    }

    if (this.debug) {
    }

    // Restaurar el valor del descuento manual si existe
    if (currentDiscountAmount > 0) {
      this.discountAmountTarget.value = currentDiscountAmount;
      if (this.debug) {
      }
    }

    // Llamar a updateNetAmount para calcular el total según la fórmula:
    // Total = Subtotal + Recargo (calculado a partir de % de Recargo) - Descuento (manual o calculado a partir de % de Descuento)
    // Indicar que hay un descuento manual si el valor es > 0
    this.updateNetAmount(currentDiscountAmount > 0);

    // Habilitar el botón de envío si todo está correcto
    this.validate();
  }

  showRuleError(message) {
    // Remover mensaje anterior si existe
    this.hideRuleError();

    // Crear y mostrar mensaje de error
    const errorDiv = document.createElement('div');
    errorDiv.className = 'alert alert-danger mt-2';
    errorDiv.id = 'payment-rule-error';
    errorDiv.innerHTML = `<strong>Error:</strong> ${message}`;

    // Insertar después del campo de payment_type
    const paymentTypeContainer = this.paymentTypeTarget.closest('.form-group') || this.paymentTypeTarget.parentElement;
    paymentTypeContainer.appendChild(errorDiv);
  }

  showRuleInfo(rechargePercentage, discountPercentage) {
    // Verificar si los targets existen antes de continuar
    if (!this.hasPaymentTargets()) {
      return;
    }

    // Mostrar información sobre la regla aplicada
    const infoSpan = document.getElementById('payment-rule-info');
    if (infoSpan) {
      // Limpiar clases existentes
      infoSpan.classList.remove('text-danger', 'text-success', 'text-info');

      // También actualizar la fila de regla de pago en la tabla
      const ruleTr = document.getElementById('payment_rule_display');
      const ruleLabel = document.getElementById('payment_rule_label');
      const ruleValue = document.getElementById('payment_rule_value');

      // Mostrar el mensaje apropiado basado en los porcentajes
      if (rechargePercentage > 0) {
        // Mostrar en el infoSpan
        infoSpan.classList.add('text-danger');
        infoSpan.textContent = `Recargo: ${rechargePercentage}%`;

        // Mostrar en la tabla
        if (ruleTr && ruleLabel && ruleValue) {
          ruleTr.style.display = '';
          ruleTr.className = 'table-danger';
          ruleLabel.textContent = `Recargo (${rechargePercentage}%)`;

          // Calcular el recargo basado en el monto bruto
          const grossAmount = parseFloat(this.grossAmountTarget.value) || 0;
          const rechargeAmount = (grossAmount * rechargePercentage / 100).toFixed(2);
          ruleValue.textContent = `+$${rechargeAmount}`;
          ruleValue.className = 'text-danger font-weight-bold';
        }

      } else if (discountPercentage > 0) {
        // Mostrar en el infoSpan
        infoSpan.classList.add('text-success');
        infoSpan.textContent = `Descuento: ${discountPercentage}%`;

        // Mostrar en la tabla
        if (ruleTr && ruleLabel && ruleValue) {
          ruleTr.style.display = '';
          ruleTr.className = 'table-success';
          ruleLabel.textContent = `Descuento (${discountPercentage}%)`;

          // Calcular el descuento basado en el monto bruto
          const grossAmount = parseFloat(this.grossAmountTarget.value.replace(/[^0-9.-]+/g,"")) || 0;
          const discountAmount = (grossAmount * discountPercentage / 100).toFixed(2);
          ruleValue.textContent = `-$${discountAmount}`;
          ruleValue.className = 'text-success font-weight-bold';
        }

      } else {
        // Mostrar en el infoSpan
        infoSpan.classList.add('text-info');
        infoSpan.textContent = 'Sin recargos ni descuentos';

        // Ocultar en la tabla
        if (ruleTr) {
          ruleTr.style.display = 'none';
        }

      }
    }
  }

  hideRuleError() {
    const errorDiv = document.getElementById('payment-rule-error');
    if (errorDiv) {
      errorDiv.remove();
    }

    // Ocultar también la información de regla
    const infoSpan = document.getElementById('payment-rule-info');
    if (infoSpan) {
      infoSpan.textContent = '';
    }

    // Ocultar la fila de regla de pago en la tabla
    const ruleTr = document.getElementById('payment_rule_display');
    if (ruleTr) {
      ruleTr.style.display = 'none';
    }

    try {
      // Resetear el total a pagar al subtotal original
      const totalToPayDisplay = document.getElementById('total_to_pay_display');
      let grossAmount = parseFloat(this.grossAmountTarget.value.replace(/[^0-9.-]+/g,"")) || 0;

      if (this.originalDisplayValue > 0) {
        grossAmount = this.originalDisplayValue;
      }

      if (totalToPayDisplay && !isNaN(grossAmount)) {
        try {
          // Formatear manualmente para usar punto (.) como separador de miles
          const grossAmountRounded = Math.round(grossAmount);
          const grossAmountString = grossAmountRounded.toString();
          const formattedAmount = '$ ' + grossAmountString.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
          totalToPayDisplay.textContent = formattedAmount;

          if (this.debug) {
          }
        } catch (error) {
          console.error('[payment_form] Error al formatear el total a pagar durante reset:', error);
          // Fallback simple en caso de error
          totalToPayDisplay.textContent = `$${Math.round(grossAmount)}`;
        }
      } else if (this.debug && !totalToPayDisplay) {
      }
    } catch (error) {
      console.error('[payment_form] Error general al resetear el total a pagar:', error);
    }
  }

  updateManualDiscount() {
    // Este método se llama cuando el usuario ingresa un monto de descuento manualmente
    if (this.debug) {
    }

    // Actualizar el total
    this.updateNetAmount(true);
  }

  updateNetAmount(isManualDiscount = false) {
    // Verificar si los targets existen antes de continuar
    if (!this.hasPaymentTargets()) {
      return;
    }

    // Este método calcula el total según la fórmula:
    // Total = Subtotal + Recargo (calculado a partir de % de Recargo) - Descuento (manual o calculado a partir de % de Descuento)

    try {
      // Obtener el subtotal (monto bruto)
      // El campo oculto grossAmount debería tener un número puro (ej: "49000.00"), no formateado
      const grossAmountRaw = this.grossAmountTarget.value;
      let subtotal = parseFloat(grossAmountRaw) || 0;

      // CRÍTICO: Usar el valor original del display guardado al conectar
      // Si no está disponible, intentar leerlo del display actual
      let initialDisplayValue = this.originalDisplayValue;

      if (initialDisplayValue === null || initialDisplayValue === undefined) {
        // Si no tenemos el valor original, intentar leerlo del display
        const totalToPayDisplay = document.getElementById('total_to_pay_display');
        if (totalToPayDisplay) {
          const displayText = totalToPayDisplay.textContent.trim();
          // Intentar parsear el valor del display (formato: "$ 24.500" o "$ 24.500,00" o "$ 24,500.00")
          // El formato argentino usa punto para miles y coma para decimales (o sin decimales)
          // Ejemplo: "$ 24.500" -> 24500, "$ 24.500,00" -> 24500.00
          let displayNumbers = displayText.replace(/[^\d.,]/g, ''); // Remover todo excepto dígitos, puntos y comas
          // Si tiene punto y coma, asumir formato argentino (punto = miles, coma = decimal)
          if (displayNumbers.includes('.') && displayNumbers.includes(',')) {
            displayNumbers = displayNumbers.replace(/\./g, '').replace(',', '.'); // Quitar puntos (miles) y convertir coma a punto
          } else if (displayNumbers.includes(',')) {
            // Solo tiene coma, podría ser decimal
            displayNumbers = displayNumbers.replace(',', '.');
          } else if (displayNumbers.includes('.')) {
            // Solo tiene punto, asumir que son miles (formato argentino sin decimales)
            displayNumbers = displayNumbers.replace(/\./g, ''); // Quitar puntos (miles)
          }
          initialDisplayValue = parseFloat(displayNumbers);

          if (this.debug) {
          }

          if (this.debug) {
          }
        }
      } else if (this.debug) {
      }

      if (this.debug) {
      }

      // SIEMPRE usar el valor del display como base si está disponible
      // Esto asegura que siempre usamos el valor correcto calculado en el servidor
      if (initialDisplayValue > 0) {
        // Si hay una discrepancia significativa, loguear una advertencia
        if (Math.abs(initialDisplayValue - subtotal) > 0.01) {
          console.warn(`[payment_form] updateNetAmount - ADVERTENCIA: Discrepancia detectada entre display (${initialDisplayValue}) y campo oculto (${subtotal})`);
          console.warn(`[payment_form] updateNetAmount - Valor raw del campo oculto: "${grossAmountRaw}"`);
        }
        // SIEMPRE usar el valor del display como base, independientemente de si hay discrepancia
        if (this.debug) {
        }
        subtotal = initialDisplayValue;
        // Actualizar el campo oculto con el valor correcto para futuras referencias
        this.grossAmountTarget.value = subtotal.toFixed(2);
      } else {
        // Si no tenemos el valor del display, validar que el campo oculto sea razonable
        // Si el subtotal es muy pequeño (menos de 100), probablemente está incorrecto
        if (subtotal > 0 && subtotal < 100) {
          console.error(`[payment_form] updateNetAmount - ERROR: Subtotal del campo oculto es sospechosamente pequeño: ${subtotal}`);
          console.error(`[payment_form] updateNetAmount - Valor raw del campo oculto: "${grossAmountRaw}"`);
          console.error(`[payment_form] updateNetAmount - Esto sugiere que el campo oculto tiene un valor incorrecto.`);
          // Intentar leer el display nuevamente como último recurso
          const totalToPayDisplay = document.getElementById('total_to_pay_display');
          if (totalToPayDisplay) {
            const displayText = totalToPayDisplay.textContent.trim();
            console.error(`[payment_form] updateNetAmount - Valor actual del display: "${displayText}"`);
          }
          // No continuar con el cálculo si el valor es claramente incorrecto
          return;
        }
        if (this.debug) {
          console.warn(`[payment_form] updateNetAmount - No se pudo obtener el valor del display, usando campo oculto: ${subtotal}`);
        }
      }

      // Validar que el subtotal sea razonable (no más de 10 millones de pesos)
      // Si es mayor, probablemente hay un error en el valor del campo oculto
      if (subtotal > 10000000) {
        console.error(`[payment_form] ERROR: Subtotal es excesivamente grande: ${subtotal}. Valor raw: "${grossAmountRaw}"`);
        console.error(`[payment_form] Esto sugiere que el campo oculto gross_amount tiene un valor incorrecto.`);
        // No continuar con el cálculo si el valor es claramente incorrecto
        return;
      }

      if (this.debug) {
      }

      // Obtener los porcentajes (0 si no hay método de pago seleccionado)
      const rechargePercentage = parseFloat(this.rechargePercentageTarget.value) || 0;
      const discountPercentage = parseFloat(this.discountPercentageTarget.value) || 0;

      if (this.debug) {
      }

      // Calcular los montos de recargo y descuento
      const rechargeAmount = (subtotal * rechargePercentage / 100);

      // Si se ingresó un descuento manual, usarlo; de lo contrario, calcularlo a partir del porcentaje
      let discountAmount;
      if (isManualDiscount && this.hasDiscountAmountTarget) {
        discountAmount = parseFloat(this.discountAmountTarget.value) || 0;
        if (this.debug) {
        }
      } else {
        discountAmount = (subtotal * discountPercentage / 100);
      }

      // Calcular el total según la fórmula
      const total = subtotal + rechargeAmount - discountAmount;

      if (this.debug) {
      }

      // Validar que el total sea razonable (no debería ser mucho menor que el subtotal)
      // Si el total es significativamente menor que el subtotal sin descuentos, hay un error
      if (rechargeAmount === 0 && discountAmount === 0 && Math.abs(total - subtotal) > 0.01) {
        console.error(`[payment_form] ERROR: Total (${total}) no coincide con subtotal (${subtotal}) cuando no hay recargos ni descuentos`);
        console.error(`[payment_form] Esto sugiere un error en el cálculo. No se actualizará el display.`);
        return;
      }

      // NO actualizar el display si no hay cambios (recargo=0, descuento=0)
      // Esto evita que el display cambie cuando se selecciona una forma de pago sin recargo/descuento
      if (rechargeAmount === 0 && discountAmount === 0 && Math.abs(total - subtotal) < 0.01) {
        if (this.debug) {
        }
        // Aún así actualizar el campo netAmount para que el formulario tenga el valor correcto
        if (this.hasNetAmountTarget) {
          this.netAmountTarget.value = total.toFixed(2);
        }
        return; // Salir sin actualizar el display
      }

      // Actualizar el campo de recargo en el formulario (este es el que se enviará al servidor)
      if (this.hasRechargeAmountTarget) {
        this.rechargeAmountTarget.value = rechargeAmount.toFixed(2);
      }

      // NO actualizar el campo de descuento manual si el usuario lo está editando
      // Solo actualizar el campo oculto que se enviará al servidor
      // El valor del input lo mantiene el usuario

      // Actualizar el campo de total en el formulario (este es el que se enviará al servidor)
      if (this.hasNetAmountTarget) {
        this.netAmountTarget.value = total.toFixed(2);
        if (this.debug) {
        }
      }

      // Actualizar también el total a pagar en la tabla (solo si hay cambios)
      this.updateFinalAmount(total);

      if (this.debug) {
      }
    } catch (error) {
      console.error('[payment_form] Error en cálculo del total:', error);
    }
  }

  updateFinalAmount(total) {
    try {
      // Actualizar el total a pagar en la tabla
      const totalToPayDisplay = document.getElementById('total_to_pay_display');
      if (totalToPayDisplay && !isNaN(total) && total > 0) {
        try {
          // Validar que el total no sea excesivamente grande (más de 10 millones de pesos)
          // Esto ayuda a detectar si hay un error de cálculo
          if (total > 10000000) {
            console.error(`[payment_form] ERROR: Total calculado es excesivamente grande: ${total}. No se actualizará el display.`);
            if (this.debug) {
              console.error(`[payment_form] Esto sugiere un error en el cálculo. Revisar el valor de grossAmount.`);
            }
            return;
          }

          // Formatear el monto como moneda (pesos, sin centavos)
          // Usar formato manual para asegurar que siempre use punto (.) como separador de miles
          const totalRounded = Math.round(total);
          // Convertir a string y agregar puntos como separadores de miles
          const totalString = totalRounded.toString();
          // Agregar puntos cada 3 dígitos desde la derecha
          const formattedAmount = '$ ' + totalString.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

          totalToPayDisplay.textContent = formattedAmount;

          if (this.debug) {
          }
        } catch (error) {
          console.error('[payment_form] Error al formatear el total a pagar:', error);
          // Fallback simple en caso de error
          totalToPayDisplay.textContent = `$${Math.round(total)}`;
        }
      } else if (this.debug && !totalToPayDisplay) {
      } else if (this.debug && (isNaN(total) || total <= 0)) {
        console.warn(`[payment_form] Total inválido: ${total}. No se actualizará el display.`);
      }
    } catch (error) {
      console.error('[payment_form] Error general en updateFinalAmount:', error);
    }

    // Actualizar el valor del recargo en la tabla
    try {
      const grossAmount = parseFloat(this.grossAmountTarget.value.replace(/[^0-9.-]+/g,"")) || 0;
      const rechargePercentage = parseFloat(this.rechargePercentageTarget.value) || 0;

      // Mostrar u ocultar la fila de recargo según corresponda
      const ruleTr = document.getElementById('payment_rule_display');
      const ruleValue = document.getElementById('payment_rule_value');

      if (rechargePercentage > 0 && ruleTr && ruleValue) {
        // Calcular el recargo
        const rechargeAmount = (grossAmount * rechargePercentage / 100);

        // Mostrar la fila de recargo
        ruleTr.style.display = '';

        try {
          // Formatear el monto como moneda
          // Formatear manualmente para usar punto (.) como separador de miles
          const rechargeAmountRounded = Math.round(rechargeAmount);
          const rechargeAmountString = rechargeAmountRounded.toString();
          const formattedRecharge = rechargeAmountString.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
          ruleValue.textContent = `+$${formattedRecharge}`;

          if (this.debug) {
          }
        } catch (formatError) {
          console.error('[payment_form] Error al formatear el recargo:', formatError);
          // Fallback simple en caso de error
          ruleValue.textContent = `+$${Math.round(rechargeAmount)}`;
        }
      } else if (ruleTr) {
        // Ocultar la fila de recargo
        ruleTr.style.display = 'none';
        if (this.debug) {
        }
      } else if (this.debug) {
      }
    } catch (error) {
      console.error('[payment_form] Error al actualizar el recargo:', error);
    }
  }

  validate() {
    // Verificar si los targets existen antes de continuar
    if (!this.hasPaymentTargets()) {
      return;
    }

    // Asegurar que los campos numéricos tengan valores por defecto en los hidden fields (los que se envían)
    // IMPORTANTE: Si no hay recargos o descuentos configurados, forzar a 0 para evitar cálculos inesperados

    // Obtener la regla actual
    const selectedPaymentType = this.paymentTypeTarget.value;
    const selectedRules = selectedPaymentType ? this.paymentRules[selectedPaymentType] : null;

    // Forzar a 0 los campos de recargo si no hay recargo configurado o es 0
    if (!selectedRules || selectedRules.recharge_percentage == null || selectedRules.recharge_percentage <= 0) {
      this.rechargeAmountTarget.value = 0;
      this.rechargePercentageTarget.value = 0;
    } else if (this.rechargeAmountTarget.value == "" || this.rechargeAmountTarget.value == null) {
      this.rechargeAmountTarget.value = 0;
    }

    // Solo forzar el porcentaje de descuento a 0, pero mantener el monto de descuento manual
    if (!selectedRules || selectedRules.discount_percentage == null || selectedRules.discount_percentage <= 0) {
      // Solo forzar el porcentaje a 0, NO el monto (para permitir descuentos manuales)
      this.discountPercentageTarget.value = 0;
    }

    // Solo inicializar el monto de descuento a 0 si está vacío o es null
    if (this.discountAmountTarget.value == "" || this.discountAmountTarget.value == null) {
      this.discountAmountTarget.value = 0;
    } else {
    }

    // Verificar valores después de la validación

    // Verificar que haya una regla completamente configurada para el medio de pago seleccionado
    // nil = no configurado, cualquier otro valor (incluido 0) = configurado
    // AMBOS porcentajes deben estar configurados (no nil)
    // Reutilizamos el paymentType que ya se obtuvo al inicio del método
    const currentPaymentType = this.paymentTypeTarget.value;
    const currentRules = currentPaymentType ? this.paymentRules[currentPaymentType] : null;
    // Una regla está correctamente configurada si ambos porcentajes no son null (pueden ser 0)
    const hasRule = currentRules && currentRules.recharge_percentage != null && currentRules.discount_percentage != null;

    // Simplificar la validación: solo requerir que se haya seleccionado un método de pago
    const allFieldsCompleted = currentPaymentType && currentPaymentType !== '';

    const discountAmountValid = parseFloat(this.discountAmountTarget.value) <= parseFloat(this.grossAmountTarget.value);

    // Imprimir información de depuración

    // Deshabilitar el botón si no hay método de pago seleccionado o si el descuento es inválido
    const shouldEnable = allFieldsCompleted && discountAmountValid;

    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = !shouldEnable;
    }
  }

  resetForm() {
    // Resetear todos los campos del formulario
    if (this.hasPaymentTypeTarget) {
      this.paymentTypeTarget.value = '';
    }
    if (this.hasRechargeAmountTarget) {
      this.rechargeAmountTarget.value = '';
    }
    if (this.hasDiscountAmountTarget) {
      this.discountAmountTarget.value = '';
    }
    if (this.hasRechargePercentageTarget) {
      this.rechargePercentageTarget.value = '';
    }
    if (this.hasDiscountPercentageTarget) {
      this.discountPercentageTarget.value = '';
    }
    if (this.hasNetAmountTarget) {
      // Restaurar el net_amount al gross_amount original
      const grossAmount = parseFloat(this.grossAmountTarget.value.replace(/[^0-9.-]+/g,""));
      this.netAmountTarget.value = grossAmount.toFixed(2);
    }
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = true;
    }

    // Ocultar mensaje de error si existe
    this.hideRuleError();

    // Resetear el formulario completo
    const form = this.element.querySelector('form');
    if (form) {
      form.reset();
    }
  }

  initTooltips() {
    // Inicializar tooltips de Bootstrap cuando se muestra el modal
    if (typeof jQuery !== 'undefined' && jQuery.fn.tooltip) {
      jQuery('[data-toggle="tooltip"]').tooltip();
    } else {
      // Fallback para Bootstrap 5
      const tooltips = document.querySelectorAll('[data-toggle="tooltip"]');
      tooltips.forEach(tooltip => {
        if (typeof bootstrap !== 'undefined' && bootstrap.Tooltip) {
          new bootstrap.Tooltip(tooltip);
        }
      });
    }
  }

  // Toggle: "Aplicar balance disponible (comidas)" cambió
  toggleCreditBalance() {
    this.recomputeBalanceApplied();
  }

  // Toggle: "Aplicar balance disponible (deliveries)" cambió
  toggleDeliveryBalance() {
    this.recomputeBalanceApplied();
  }

  // Recalcula el monto a cobrar según el estado de los toggles de balance
  // Muestra/oculta filas, actualiza el subtotal post-balance, gross/net amount,
  // total_to_pay_display, y propaga al cálculo de payment rules si hay forma de pago elegida.
  recomputeBalanceApplied() {
    const creditToggle = document.getElementById('apply_credit_balance_toggle');
    const deliveryToggle = document.getElementById('apply_delivery_balance_toggle');
    const creditApplied = creditToggle ? creditToggle.checked : true;
    const deliveryApplied = deliveryToggle ? deliveryToggle.checked : true;

    const creditRow = document.getElementById('credit_balance_applied_row');
    const deliveryRow = document.getElementById('delivery_balance_applied_row');
    const subtotalRow = document.getElementById('subtotal_after_balance_row');

    const creditBalanceCents = creditRow ? parseInt(creditRow.dataset.balanceAppliedCents || '0', 10) : 0;
    const deliveryBalanceCents = deliveryRow ? parseInt(deliveryRow.dataset.deliveryBalanceAppliedCents || '0', 10) : 0;
    const subtotalAfterBalanceCents = subtotalRow ? parseInt(subtotalRow.dataset.subtotalAfterBalanceCents || '0', 10) : 0;

    // Mostrar/ocultar filas en la tabla
    if (creditRow) creditRow.style.display = creditApplied ? '' : 'none';
    if (deliveryRow) deliveryRow.style.display = deliveryApplied ? '' : 'none';

    // Visual feedback en las labels de la alert (tachado cuando está apagado)
    const creditLabel = document.getElementById('credit_balance_applied_label');
    if (creditLabel) {
      creditLabel.style.textDecoration = creditApplied ? '' : 'line-through';
      creditLabel.style.opacity = creditApplied ? '' : '0.5';
    }
    const deliveryLabel = document.getElementById('delivery_balance_applied_label');
    if (deliveryLabel) {
      deliveryLabel.style.textDecoration = deliveryApplied ? '' : 'line-through';
      deliveryLabel.style.opacity = deliveryApplied ? '' : '0.5';
    }

    // Calcular el nuevo gross según los toggles
    // base = subtotalAfterBalance (ambos balances aplicados); destildados se SUMAN de vuelta
    let newGrossCents = subtotalAfterBalanceCents;
    if (!creditApplied) newGrossCents += creditBalanceCents;
    if (!deliveryApplied) newGrossCents += deliveryBalanceCents;
    const newGrossPesos = newGrossCents / 100.0;

    // Actualizar el subtotal después de balance en la tabla
    const subtotalSpan = document.getElementById('subtotal_after_balance_value');
    if (subtotalSpan) {
      subtotalSpan.textContent = this.formatARS(newGrossPesos);
    }
    // Si ambos balances están destildados, ocultar la fila Subtotal post-balance (no aporta info)
    if (subtotalRow) {
      subtotalRow.style.display = (creditApplied || deliveryApplied) ? '' : 'none';
    }

    // Sincronizar grossAmount (campo oculto), originalDisplayValue (cache) y net_amount
    if (this.hasGrossAmountTarget) {
      this.grossAmountTarget.value = newGrossPesos.toFixed(2);
    }
    this.originalDisplayValue = newGrossPesos;
    if (this.hasNetAmountTarget) {
      this.netAmountTarget.value = newGrossPesos.toFixed(2);
    }

    // Actualizar el "Total a pagar" display
    const totalDisplay = document.getElementById('total_to_pay_display');
    if (totalDisplay) {
      totalDisplay.textContent = this.formatARS(newGrossPesos);
    }

    // Si ya hay forma de pago seleccionada, recalcular recargo/descuento
    if (this.hasPaymentTypeTarget && this.paymentTypeTarget.value) {
      this.updateAmounts();
    }
  }

  // Formatea un número como moneda argentina ($ XX.XXX)
  formatARS(amount) {
    const rounded = Math.round(amount);
    return '$ ' + rounded.toLocaleString('es-AR');
  }

  closeModal(event) {
    // Resetear formulario cuando se cierra manualmente (botón cerrar o volver)
    this.resetForm();

    // Cerrar el modal
    const modal = document.getElementById('orderSummary');
    if (modal) {
      if (typeof jQuery !== 'undefined' && jQuery(modal).modal) {
        jQuery(modal).modal('hide');
      }

      // Limpiar backdrop
      setTimeout(() => {
        const backdrop = document.querySelector('.modal-backdrop');
        if (backdrop) {
          backdrop.remove();
        }
        document.body.classList.remove('modal-open');
        document.body.style.paddingRight = '';
      }, 300);
    }
  }
}
